import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';

export interface NapkinState {
  quantity: number;
  color: string;
  orientation: 'diamond' | 'square';
  foilColor: string;
  textLineOne: string;
  textLineTwo: string;
  font: string;
  image: string;
  status: 'initialized' | 'customizing' | 'in-cart' | 'paid' | 'executing' | 'awaiting-shipment' | 'shipped' | 'delivered' | 'reviewed';
}

const initialState: NapkinState = {
  quantity: 100,
  color: 'white',
  orientation: 'square',
  foilColor: 'Black',
  textLineOne: 'Click Here to Type',
  textLineTwo: 'Click Here to Type',
  font: 'Mayfair',
  image: 'a0',
  status: 'initialized'
};

export const napkinSlice = createSlice({
  name: 'napkin',
  initialState,
  reducers: {
    setQuantity: (state, action: PayloadAction<number>) => {
      state.quantity = action.payload;
    },
    setColor: (state, action: PayloadAction<string>) => {
      state.color = action.payload;
    },
    setOrientation: (state, action: PayloadAction<'diamond' | 'square'>) => {
      state.orientation = action.payload;
    },
    setFoilColor: (state, action: PayloadAction<string>) => {
      state.foilColor = action.payload;
    },
    setTextLineOne: (state, action: PayloadAction<string>) => {
      state.textLineOne = action.payload;
    },
    setTextLineTwo: (state, action: PayloadAction<string>) => {
      state.textLineTwo = action.payload;
    },
    setFont: (state, action: PayloadAction<string>) => {
      state.font = action.payload;
    },
    setImage: (state, action: PayloadAction<string>) => {
      state.image = action.payload;
    },
    setStatus: (state, action: PayloadAction<NapkinState['status']>) => {
      state.status = action.payload;
    },
  },
});

export const {
  setQuantity,
  setColor,
  setOrientation,
  setFoilColor,
  setTextLineOne,
  setTextLineTwo,
  setFont,
  setImage,
  setStatus,
} = napkinSlice.actions;

// Selectors
export const selectNapkin = (state: RootState) => state.napkin;
export const selectQuantity = (state: RootState) => state.napkin.quantity;
export const selectColor = (state: RootState) => state.napkin.color;
export const selectOrientation = (state: RootState) => state.napkin.orientation;
export const selectFoilColor = (state: RootState) => state.napkin.foilColor;
export const selectTextLineOne = (state: RootState) => state.napkin.textLineOne;
export const selectTextLineTwo = (state: RootState) => state.napkin.textLineTwo;
export const selectFont = (state: RootState) => state.napkin.font;
export const selectImage = (state: RootState) => state.napkin.image;
export const selectStatus = (state: RootState) => state.napkin.status;

export default napkinSlice.reducer;
